/* eslint-disable @typescript-eslint/no-explicit-any */

import { TreeNodeRoute, TreeNodeType } from "pages/thermography/components/InspectionRouteTree/types/treeNode";

export interface TreeAdapter<TGroup, TEquipment> {
    getId: (g: TGroup) => string | undefined;
    getName: (g: TGroup) => string | null;
    getCode: (g: TGroup) => string | null;
    getIncluded: (g: TGroup) => boolean;
    getOrderIndex: (g: TGroup) => number;

    getSubGroups: (g: TGroup) => TGroup[];
    getEquipments: (g: TGroup) => TEquipment[];

    getEquipmentOrder: (eq: TEquipment) => number;

    equipmentToNode: (eq: TEquipment, parentId: string) => TreeNodeRoute;
}

export function backendGroupsToTreeNodes<TGroup, TEquipment>(
    groups: TGroup[],
    adapter: TreeAdapter<TGroup, TEquipment>
): TreeNodeRoute[] {

    if (!Array.isArray(groups)) return [];

    return groups
        .sort((a, b) => adapter.getOrderIndex(a) - adapter.getOrderIndex(b))
        .map((g) => groupToTreeNode(g, null, adapter));
}

function groupToTreeNode<TGroup, TEquipment>(
    group: TGroup,
    parentId: string | null,
    adapter: TreeAdapter<TGroup, TEquipment>
): TreeNodeRoute {

    const id = adapter.getId(group) ?? "";

    const childGroups = adapter.getSubGroups(group)
        .sort((a, b) => adapter.getOrderIndex(a) - adapter.getOrderIndex(b))
        .map(sg => groupToTreeNode(sg, id, adapter));

    const equipmentNodes = adapter.getEquipments(group)
        .sort((a, b) => adapter.getEquipmentOrder(a) - adapter.getEquipmentOrder(b))
        .map(eq => adapter.equipmentToNode(eq, id));

    const name = adapter.getName(group);
    const code = adapter.getCode(group);

    return {
        id,
        type: parentId === null ? TreeNodeType.GROUP : TreeNodeType.SUBGROUP,
        parentId,
        name,
        code,
        included: adapter.getIncluded(group),
        orderIndex: adapter.getOrderIndex(group),
        title:
            name && code ? `${name} (${code})`
                : name ?? code ?? "Sem nome",

        children: [...childGroups, ...equipmentNodes]
    };
}